import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const SwitchVertical = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M21 17.1285L17.613 20.6838C17.2113 21.1054 16.5601 21.1054 16.1584 20.6838L12.7714 17.1285M11.2286 6.87151L7.84159 3.31623C7.43991 2.89459 6.78866 2.89459 6.38698 3.31623L3 6.87151M16.8857 19.5578L16.8857 3.09262M7.11429 20.9074L7.11429 4.1723'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        d='M12.2285 17.6454C11.9431 17.3456 11.9544 16.8715 12.2539 16.5858C12.5538 16.3001 13.0288 16.3113 13.3145 16.6112L16.1358 19.5741V3.09263L16.1397 3.01548C16.1782 2.63744 16.4976 2.34263 16.8858 2.34263C17.274 2.34264 17.5933 2.63745 17.6319 3.01548L17.6358 3.09263V19.5575C17.6358 19.563 17.6349 19.5686 17.6348 19.5741L20.4571 16.6112C20.7428 16.3113 21.2177 16.3001 21.5176 16.5858C21.8171 16.8715 21.8285 17.3456 21.543 17.6454L18.1563 21.201C17.4591 21.9329 16.3125 21.9329 15.6153 21.201L12.2285 17.6454ZM11.7715 6.35435C12.057 6.65415 12.0457 7.12821 11.7461 7.41392C11.4462 7.69963 10.9713 7.68843 10.6856 7.38853L11.7715 6.35435ZM2.48246 7.41392C2.18296 7.12821 2.1716 6.65414 2.45707 6.35435L5.84378 2.79869L5.97953 2.66978C6.68251 2.06944 7.73115 2.11256 8.3848 2.79869L11.7715 6.35435L10.6856 7.38853L7.86429 4.42759L7.86429 20.9071C7.86429 21.3213 7.52851 21.6571 7.11429 21.6571C6.70009 21.6571 6.36429 21.3213 6.36429 20.9071L6.36429 4.42759L3.543 7.38853C3.25729 7.68843 2.78236 7.69963 2.48246 7.41392Z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
